import { useApi } from '@src/app/context/Api';
import { User } from '@src/entities/User/ui/components/User';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Link } from '@uhg-abyss/web/ui/Link';
import { Popover } from '@uhg-abyss/web/ui/Popover';
import { isNull } from 'lodash';
import React, { useEffect, useState } from 'react';

import { PopoverContent } from './components/PopoverContent';

/**
 * ExportSharePoint
 *
 * @TODO Needs description.
 *
 * @param currentEntity
 * @param exportDetails
 * @param exportRefetch
 * @param pollingRate
 * @param riskRecordCount
 * @param setPollingRate
 * @returns {Element}
 * @constructor
 */
export function ExportSharePoint({
  currentEntity = {},
  exportDetails = {},
  exportRefetch = () => {},
  pollingRate = 0,
  riskRecordCount = 0,
  setPollingRate = () => {},
}) {
  const [isDisabled, setIsDisabled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const { clearApiCache, useApiMutation } = useApi('RiskRecord');

  const [ScheduleExport] = useApiMutation('ScheduleExport');

  /**
   * toggles the enabled/disabled status of the export button.
   */
  useEffect(() => {
    if (isNull(pollingRate) || !['RUNNING', 'SCHEDULED'].includes(exportDetails?.status)) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [pollingRate, exportDetails]);

  /**
   * handleScheduleExport
   *
   * @TODO Needs description.
   *
   * @returns {Promise<void>}
   */
  const handleExport = async () => {
    setIsDisabled(true);
    await ScheduleExport(
      { actionPathId: currentEntity?.id },
      {
        onError: async () => {
          await clearApiCache([{ apiKey: 'RiskRecord', queryKeys: ['GetExportDetails'] }]);
          exportRefetch();
          setIsDisabled(false);
          setPollingRate(null);
        },
        onSuccess: async () => {
          await clearApiCache([{ apiKey: 'RiskRecord', queryKeys: ['GetExportDetails'] }]);
          exportRefetch();
          setIsDisabled(true);
          setPollingRate(5000);
        },
      }
    );
  };

  return (
    <ErrorHandler location="src/features/Risk/components/tables/RiskRecords/components/Header/components/ExportSharePoint/ExportSharePoint.jsx">
      <Popover
        align="start"
        alignOffset={50}
        content={<PopoverContent currentEntity={currentEntity} handleExport={handleExport} setIsOpen={setIsOpen} />}
        onOpenChange={() => {
          setIsOpen(!isOpen);
        }}
        open={isOpen}
        position="bottom"
        width={275}
      >
        <User.Capability attributes={['export']} resource="ActionPaths">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link
            before={
              <IconSymbol
                color={isDisabled ? 'var(--abyss-colors-gray5)' : 'var(--abyss-colors-interactive1)'}
                icon="upload_2"
              />
            }
            hideIcon
            isDisabled={isDisabled}
            onClick={async (event) => {
              event?.preventDefault();
              if (riskRecordCount > 1000000) {
                setIsOpen(true);
              } else {
                setIsDisabled(true);
                await handleExport();
              }
            }}
          >
            Export to SharePoint
          </Link>
        </User.Capability>
      </Popover>
    </ErrorHandler>
  );
}
